"use client";
import { createTRPCClient, httpLink, splitLink } from "@trpc/client";
import { httpBatchLink } from "@trpc/client/links/httpBatchLink";
import type { LegalImageRouter } from "../pages/api/legal-image/[trpc]";
import type { AppRouter } from "../pages/api/[trpc]";

export const API_URL = "/api";
export const LEGAL_IMAGE_API_URL = "/api/legal-image";

export const api = createTRPCClient<AppRouter>({
  links: [
    splitLink({
      condition(op) {
        return Boolean(op.context.skipBatch);
      },

      true: httpLink({
        url: API_URL,
      }),

      false: httpBatchLink({
        url: API_URL,
      }),
    }),
  ],
});

/**
 * The legal document image upload lives on its own route, because the body
 * parser ceiling it needs is a route-level Next setting and would otherwise
 * apply to every procedure on /api, the unauthenticated ones included.
 *
 * It never batches: the route's ceiling is sized for exactly one upload, so
 * putting an unrelated payload in the same request could push it over.
 */
export const legalImageApi = createTRPCClient<LegalImageRouter>({
  links: [
    httpLink({
      url: LEGAL_IMAGE_API_URL,
    }),
  ],
});
